// extracted by mini-css-extract-plugin
module.exports = {"khata_box":"PropertyKhata-module--khata_box--1mTL-","radio_position":"PropertyKhata-module--radio_position--3baUt"};